import { render, staticRenderFns } from "./QuantidadeEscolher.vue?vue&type=template&id=0608e283&scoped=true&"
import script from "./QuantidadeEscolher.vue?vue&type=script&lang=js&"
export * from "./QuantidadeEscolher.vue?vue&type=script&lang=js&"
import style0 from "./QuantidadeEscolher.vue?vue&type=style&index=0&id=0608e283&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0608e283",
  null
  
)

export default component.exports